export const program = [
  {
    id: 1,
    name: 'Diabetes Program',
    duration: 12,
    visitsAllowed: 33,
    parentProgramId: null,
    siteId: 1319,
    targetId: 8670,
    createdAt: '2020-11-30T22:19:19.139Z',
    updatedAt: '2021-02-11T16:15:04.848Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 2,
    name: 'Program 11/18 - Lus',
    duration: 11,
    visitsAllowed: 12,
    parentProgramId: null,
    siteId: 1411,
    targetId: 8669,
    createdAt: '2020-11-18T12:45:54.941Z',
    updatedAt: '2020-11-18T12:45:54.941Z',
    createdBy: null,
    updatedBy: null,
  },
];
